import { useActionConfirm } from './useActionConfirm';

export const STOPPING_COLLABORATION_TITLE = 'Stopping Collaboration';

/**
 * Action hook for the stop-collaboration flow.
 * @param {{ stopCollaboration: Function, showToast: Function }} deps
 * @returns {import('./useActionConfirm').ActionHook}
 */
export function useCollaborativeAction({ stopCollaboration, showToast }) {
  return useActionConfirm(() => STOPPING_COLLABORATION_TITLE, stopCollaboration, showToast);
}
